/**
 * Movement-ability travel feel — single knob file (config-driven, 2026-06-11).
 *
 * Charge / Heroic Leap used to be instant position blinks (DashBehavior did
 * `position.x += dx` in one frame). DJ: "Charge ... is like a blink ... it
 * should be a charge." Travel-mode dashes now move through the prediction
 * loop as a short velocity window (see `DashTravelState`); these constants
 * set the feel. Charge deliberately carries no windUpMs — the travel
 * time IS the wind-up feel, so do NOT add a cast windup on top.
 */
export const MOVEMENT_TRAVEL_CONFIG = {
  dash: {
    /** Ground-dash travel time for a full-distance dash (ms). ~300px/250ms = 1200px/s. */
    durationMs: 250,
  },
  leap: {
    /** Airborne time target for the leap arc (ms). Launch vy is derived from this. */
    durationMs: 450,
    /**
     * Hard safety cap (× durationMs) — if the leaper never re-grounds
     * (leapt off a ledge), the travel window force-completes here.
     */
    maxAirborneFactor: 3,
    /** Landing beat VFX (the AOE damage already fires — this is the visual cue). */
    landingVfxId: 'ground_impact',
  },
  trail: {
    /** Emit a trail one-shot every N ms while travelling. */
    intervalMs: 40,
    /** Lifetime of each trail one-shot (ms) — short fade = afterimage feel. */
    durationMs: 220,
  },
} as const;
